import { Component, OnInit, AfterViewInit, Input, Output, EventEmitter } from '@angular/core';
import { ViewChild, } from '@angular/core';
import { ElementRef } from '@angular/core';
import { Renderer2 } from '@angular/core';
import { ViewEncapsulation } from '@angular/core';
import { OnChange } from 'src/app/custom-decorators/ngOnchanges.Decorator';
@Component({
  selector: 'app-reaction-animation',
  templateUrl: './reaction-animation.component.html',
  styleUrls: ['./reaction-animation.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ReactionAnimationComponent implements OnInit,AfterViewInit {
  @Input() emojiUrl: string;
  @Input() emojiIndex: number
  @Input() emojiCount;
  @ViewChild('animateDiv') animateDiv: ElementRef;
  @Input() type = 2;

  @Input() startPosition: number

  @OnChange<boolean>('onReloadAnimation')
  @Input() reloadAnimation;

  @Output() animationEnd : EventEmitter<boolean> = new EventEmitter();

  constructor(private renderer: Renderer2) { }
   getRandomArbitrary(min, max) {
    return Math.random() * (max - min) + min;
}


myLoop(anim: HTMLElement, i): boolean{   
  setTimeout(() =>{   //  call a 3s setTimeout when the loop is called
    const p: HTMLParagraphElement = this.renderer.createElement('div');
    const x = this.emojiIndex*48 + this.getRandomArbitrary(0,30);

    const app = '<div class="position-relative" style = "left: '+ x+'px;"'+'><img src = "'+this.emojiUrl+'" width="30px" height="30px" class="emoji"></div>';
    p.innerHTML = app;
    this.renderer.appendChild(this.animateDiv.nativeElement, p);
    if (i === this.emojiCount-1) {
      setTimeout(() => {
        this.animationEnd.emit(true);
      }, 1000);
      return true;
    }  
    i++;                   
    return this.myLoop(anim, i);             //  ..  again which will trigger another 
  }, 300);
  return true;
}

 


  ngOnInit(): void {
    // no code
  }

  onReloadAnimation(): void {
    document.getElementById('animateDiv').innerHTML = '';
    this.ngAfterViewInit();
  }
  ngAfterViewInit(): void {
    if (this.emojiUrl) {
      const anim = document.getElementById('animateDiv');
      this.myLoop(anim, 0);
    }
  }
}
